<template>
  <v-card :loading="!users">
    <v-card-title>
      {{ $t("admin.users.staff") }}

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('admin.users.search')"
        single-line
        hide-details
        color="secondary"
      ></v-text-field>
    </v-card-title>

    <v-data-table
      v-if="users"
      :headers="headers"
      :items="items"
      :search="search"
      :no-results-text="$t('admin.users.noResults')"
      dense
      multi-sort
    >
      <template #item.actions="{ item }">
        <v-btn :to="{ name: 'adminUser', params: { id: item.id } }" color="secondary" small icon>
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { map, filter } from "ramda";
import AdminUsersQuery from "@/gql/queries/AdminUsers.gql";

export default {
  data() {
    return {
      search: "",
      users: null,
    };
  },

  apollo: {
    users: {
      query: AdminUsersQuery,
    },
  },

  computed: {
    staffUsers() {
      return filter((user) => user.state === "STAFF", this.users);
    },

    items() {
      return !this.staffUsers
        ? null
        : map(
            (user) => ({
              ...user,
              name: user.firstname || user.lastname ? `${user.firstname} ${user.lastname}` : "",
            }),
            this.staffUsers
          );
    },

    headers() {
      return [
        {
          text: this.$t("admin.users.name"),
          value: "name",
          width: "100%",
        },
        {
          text: "",
          value: "actions",
          filterable: false,
          sortable: false,
          align: "right",
        },
      ];
    },
  },
};
</script>
